module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "1write.bb0c16f7.svg";